<div class="signup-container" [ngClass]="{'dark-theme': (themeService.currentTheme$ | async) === 'dark'}">
  <div class="signup-card">
    <div class="signup-header">
      <img src="assets/images/innovadoc-logo.png" alt="Innovadoc IA" class="signup-logo">
      <h1 class="signup-title">{{ translate('auth.create_account') }}</h1>
    </div>

    <div class="signup-body">
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <p class="signup-description">
        {{ translate('auth.signup_description') }}
      </p>

      <div class="signup-buttons">
        <button class="btn btn-primary btn-lg btn-block" (click)="signup()" [disabled]="isLoading">
          <i class="fas fa-user-plus me-2"></i>
          {{ translate('auth.create_account') }}
        </button>

        <div class="signup-divider">
          <span>{{ translate('auth.or') }}</span>
        </div>

        <button class="btn btn-outline-secondary btn-lg btn-block" (click)="login()" [disabled]="isLoading">
          <i class="fas fa-sign-in-alt me-2"></i>
          {{ translate('auth.back_to_login') }}
        </button>
      </div>

      <div class="signup-loading" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ translate('auth.loading') }}</span>
        </div>
        <p>{{ translate('auth.redirecting') }}</p>
      </div>
    </div>

    <div class="signup-footer">
      <p>{{ translate('auth.powered_by') }} <strong>Innovadoc IA</strong></p>
      <div class="signup-language">
        <button class="btn btn-sm" (click)="languageService.setLanguage('es')"
          [ngClass]="{'btn-primary': (languageService.currentLang$ | async) === 'es', 'btn-outline-secondary': (languageService.currentLang$ | async) !== 'es'}">
          ES
        </button>
        <button class="btn btn-sm" (click)="languageService.setLanguage('en')"
          [ngClass]="{'btn-primary': (languageService.currentLang$ | async) === 'en', 'btn-outline-secondary': (languageService.currentLang$ | async) !== 'en'}">
          EN
        </button>
      </div>
    </div>
  </div>
</div>